import { render, staticRenderFns } from "./ColumnCreate.vue?vue&type=template&id=68562ca9&scoped=true&"
import script from "./ColumnCreate.vue?vue&type=script&lang=js&"
export * from "./ColumnCreate.vue?vue&type=script&lang=js&"
import style0 from "./ColumnCreate.vue?vue&type=style&index=0&id=68562ca9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68562ca9",
  null
  
)

export default component.exports